import {userService} from '../services/service-factory';

export default {
  data: function() {
    return {
      userService: undefined
    };
  },
  created: function() {
    this.userService = userService;
  }
};
